import React from 'react';
import Button from 'components/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { DASHBOARD_ROUTES } from 'Routes';
import ModalCustom from 'components/Modal';
import { deleteCompany } from 'data/api/company.api';
import { toast } from 'react-toastify';

type TModalDeleteCompanyProps = {
  modalDeleteDialog: boolean;
  setModalDeleteDialog: any;
};

export const ModalDeleteCompany: React.FC<TModalDeleteCompanyProps> = ({
  modalDeleteDialog,
  setModalDeleteDialog,
}) => {
  const navigate = useNavigate();
  const { company_id } = useParams();

  const handleDeleteCompany = async () => {
    try {
      if (company_id) {
        await deleteCompany(company_id).then(() => {
          toast.success('Delete company successfully!');
          navigate(DASHBOARD_ROUTES.COMPANY_LIST);
        });
      }
    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Delete company failed');
    }
  };

  const handleSubmitDelete = () => {
    setModalDeleteDialog(false);
    handleDeleteCompany();
  };

  return (
    <ModalCustom
      title={'Are you sure you want to delete this Company?'}
      open={modalDeleteDialog}
      subTittle={
        'Deleting this company will delete all related users and notes tied to this company. '
      }
      handleClose={() => setModalDeleteDialog(false)}
      groupButton={
        <>
          <Button
            onClick={() => setModalDeleteDialog(false)}
            variant="contained"
            color="primary"
            sx={{
              fontWeight: 700,
              fontSize: '14px',
              width: '97px',
              height: '40px',
              lineHeight: '20px',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitDelete}
            variant="outlined"
            sx={{
              color: '#B3261E',
              fontWeight: 700,
              fontSize: '14px',
              width: '97px',
              height: '40px',
              lineHeight: '20px',
              border: '1px solid #213B54',
            }}
          >
            Delete
          </Button>
        </>
      }
    />
  );
};
